  <template>
  <v-dialog v-model="modal" max-width="700">
    <v-form ref="form" :readonly="working">
      <v-card>
        <v-card-title> Inviter un usager</v-card-title>
        <v-card-text>
          <p>
            Veuillez saisir le courriel de l'usager que vous souhaitez inviter.
            Il recevra par courriel, un lien lui donnant un accès à cette
            association.
          </p>
          <v-text-field
            dense
            filled
            label="Courriel"
            v-model="email"
            :rules="[serverRule('email')]"
            data-testid="email"
          />
           <v-text-field
            dense
            filled
            label="Fonction"
            v-model="fonction"
            :rules="[serverRule('fonction')]"
            data-testid="fonction"
          />
          <v-checkbox
            dense
            label="Droit de gestion"
            v-model="gestion"
            :rules="[serverRule('gestion')]"
            data-testid="droit-gestion"
          />
          <p class="accent-block">
            Permet de gérer les utilisateurs, notamment en inviter de nouveaux.
          </p>
          <v-checkbox
            dense
            label="Droit de dépôt"
            v-model="depot"
            :rules="[serverRule('depot')]"
            data-testid="droit-depot"
          />
          <p class="accent-block">
            Permet de déposer des requêtes au nom de l'association.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn data-testid="valider-inviter-usager" :loading="working" @click="confirme" color="primary">
            Envoyer
          </v-btn>
          <v-btn data-testid="annulet-inviter-usager" :disabled="working" @click="ferme">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import makeRules from "@/mixins/makeRules";
import { associationService } from "@/services";
export default {
  mixins: [makeRules({ inject: false }), makeRemoteWorker({ provide: false })],
  data() {
    return {
      modal: false,
      email: null,
      fonction: null,
      gestion: false,
      depot: false,
      association: null,
    };
  },
  methods: {
    ouvre(association, callback) {
      this.email = null;
      this.gestion = false;
      this.depot = false;
      this.association = association;
      this.fonction = null;
      this.modal = true;
      this.callback=callback;
      this.clearValidation();
      this.$nextTick(()=>{
        this.$refs.form.resetValidation();
      });
    },
    ferme() {
      this.modal = false;
    },
    confirme() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return associationService.invitationUsager(this.association, this.email, this.fonction, this.gestion, this.depot);
        },
        callback(valeur) {
          this.callback(valeur);
          this.ferme();
        },
        successText: "L'invitation a été envoyée.",
        errorText: "Erreur durant l'envoi de l'invitation.",
      });
    },
  },
};
</script>

